import { Box, Theme, styled } from '@material-ui/core';

export const BlockRowContentStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left',
  width: '100%',
});

export const ClusterContentWrapperStyled = styled('div')<Theme, { readmode: 'true' | 'false' }>(
  ({ theme, readmode }) => ({
    position: 'relative',
    // background: 'yellow',
    padding: '1rem 0.5rem 0.5rem 0.5rem',
    background: readmode === 'true' ? theme.palette.grey['100'] : theme.palette.common.white,
    border: `1px  solid #B6B0A3`,
    borderTop: 0,
  })
);

export const NoBlocksMessageStyled = styled('div')<Theme>(({ theme }) => ({
  fontSize: theme.typography.h4.fontSize,
  fontStyle: 'italic',
  color: theme.palette.grey['600'],
}));

export const ClusterRowBodyWrapperStyled = styled('div')<Theme, { readmode?: 'true' | 'false' }>(
  ({ theme, readmode }) => ({
    marginBottom: theme.spacing(1),
    background: readmode === 'true' ? theme.palette.grey['100'] : 'transparent',
  })
);

export const PageBlocksWrapperStyled = styled('div')<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(3),
  minHeight: '2rem',
  border: '1px solid lightgrey',
  padding: '2rem',
}));

export const StyledContent = styled(Box)<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  boxShadow: 'none',
}));

export const RowWrapper = styled('div')<Theme>(({ theme }) => ({
  width: '95%',
  marginBottom: 0,
  minHeigth: '2rem',
  '&.is-cluster': {
    marginBottom: '1rem',
    minHeight: '3rem',
  },
}));
